export default __webpack_public_path__ + "images/0x97d367a5f900f5c9db4370d0d801fc52332244c7.png";